import "./couple.css";

const NoPhotoCouple = ({ values }) => {

  const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t1-couple-person">

        <div className="t1-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t1-couple-name">
          {fullname}
        </h1>

        <div className="t1-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });

  return (
    <div className="t1-couple-section t1-nophoto-couple">

      <picture>

        <source
          media="(min-width:768px)"
          srcSet="/theme1-couple-frame-desktop.png"
        />

        <img
          src="/floral1-mobile-frame-extended.png"
          alt="Couple Frame"
          className="t1-couple-frame"
        />

      </picture>

      <div className="t1-couple-inner">

        <h2 className="t1-couple-heading">
          {values.sectionHeading}
        </h2>

        <div className="t1-couple-content">

          {values.displayOrder === "groomFirst" ? (
            <>
              {groomCard()}

              <div className="t1-couple-divider">
                &
              </div>

              {brideCard()}
            </>
          ) : (
            <>
              {brideCard()}

              <div className="t1-couple-divider">
                &
              </div>

              {groomCard()}
            </>
          )}

        </div>

      </div>

    </div>
  );
};

export default NoPhotoCouple;